import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class Rebalance {
    async getInstalacoes(filters: any) {
        return await api.get<IPayload>(
            `${resources.rebalanceUsinaInstalacao}/GetInstalacoes/${ToQueryString(filters)}`
        );
    }

    async getWithFilter(filters: any) {
        return await api.get<any>(`${resources.rebalanceUsinaInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getDetail(filters: any) {
        return await api.get<any>(`${resources.rebalanceUsinaInstalacao}/Detail/${ToQueryString(filters)}`);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.rebalanceUsinaInstalacao}/Update`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.rebalanceUsinaInstalacao}/Delete/${id}`);
    }

    async deleteMany(filters: any) {
        return await api.delete<any>(`${resources.rebalanceUsinaInstalacao}/DeleteMany/${ToQueryString(filters)}`);
    }
}

export default new Rebalance();
